module.exports = __WEBPACK_EXTERNAL_MODULE_99__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/dashboard-common/dist/core/APIFactory"
// module id = 99
// module chunks = 0 1